import type { ReactNode } from "react";

interface Props {
  title: string;
  subtitle?: string;
  icon?: ReactNode;
  actions?: ReactNode;
}

export default function PageHeader({ title, subtitle, icon, actions }: Props) {
  return (
    <div className="flex items-start justify-between gap-3 mb-6 sm:mb-7">
      <div className="min-w-0 flex-1 mr-1 flex items-start gap-3.5">
        {icon && (
          <div className="flex items-center justify-center flex-shrink-0 w-12 h-12 rounded-2xl bg-esm-cream-50 border border-esm-gray-100 text-esm-brown-700">
            {icon}
          </div>
        )}
        <div className="min-w-0 pt-0.5">
          <h2 className="font-display font-medium text-esm-gray-900 text-[28px] sm:text-[34px] leading-[1.08] tracking-[-0.01em]">{title}</h2>
          {subtitle && <p className="text-sm text-esm-gray-400 mt-1.5 max-w-2xl leading-snug">{subtitle}</p>}
        </div>
      </div>
      {actions && <div className="flex items-center gap-2 flex-shrink-0">{actions}</div>}
    </div>
  );
}
